@if (!isHidden) {
  <div class="announcement-banner" [attr.data-variant]="variant" role="region" aria-live="polite">
    <div class="announcement-icon">
      <i eIcon [icon]="icon"></i>
    </div>
    <div class="announcement-message">
      @if (title) {
        <b>{{ title }}</b>
      }
      @if (message) {
        <span class="announcement-text">{{ message }}</span>
      }
    </div>
    <div class="announcement-actions">
      <ng-content select="[actions]"></ng-content>
    </div>
    @if (closable) {
      <button
        type="button"
        class="announcement-close"
        (click)="close()"
        aria-label="Sluiten"
        >
        <i eIcon icon="times"></i>
      </button>
    }
  </div>
}
